/*
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-01 18:26:49
 * @LastEditors: w9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-01-03 14:56:29
 * @FilePath: \sns-user-frontend\src\stores\search.js
 * @Description: 搜索页仓库
 */
import { defineStore, storeToRefs } from 'pinia'

export const useMsgStore = defineStore('msgStore', {
  state: () => ({
    msgNum: {}
  }),
  getters: {
    loopTime (state) {
      return state.msgNum.loopTime || 30
    },
    showDot (state) {
      const { 
        notificationDot,
        activitiesDot,
        followersDot,
        messagesDot,
        likesDot
      } = state.msgNum
      const num = notificationDot + activitiesDot + followersDot + messagesDot + likesDot
      return num > 0
    }
  },
  actions: {
    
  }

})